<template>
  <div>
    <div class="step-single upcoming" v-show="step.upcoming">
      <div class="step-title">
        {{ T__("Event type duration &amp; timings") }}
      </div>
    </div>
    <div
      class="step-single form active"
      v-show="step.form"
      :id="'service_form_step' + step.id"
    >
      <div class="step-title">
        {{ T__("Event Type Duration &amp; Timings") }}
      </div>
      <div class="form">
        <form-row :validator="$v.form.duration">
          <label>{{ T__("Event duration") }}</label>
          <span class="txt-help pt0">{{
            T__("Define how long the event will last.")
          }}</span>
          <InlineRadioSelector
            :element_settings="event_duration_element_setting"
            :form="form"
            :$v="$v"
          ></InlineRadioSelector>
        </form-row>
        <form-row
          :validator="$v.form.default_availability_details.date_range_type"
        >
          <label>{{ T__("When can this event be booked?") }}</label>
          <span class="txt-help pt0">{{
            T__("Select a time range within which this event can be booked.")
          }}</span>
          <ul class="selector block mt10">
            <li>
              <input
                type="radio"
                id="days-into-future"
                name="event-can-be-booked"
                value="relative"
                v-model="form.default_availability_details.date_range_type"
              />
              <label for="days-into-future">
                <div class="txt-h5">
                  <input
                    type="number"
                    v-model="show_relative_date_range"
                    @blur="
                      $v.form.default_availability_details.date_misc.$touch()
                    "
                    @focus="
                      form.default_availability_details.date_range_type =
                        'relative'
                    "
                    style="width: 50px; height: 33px; text-align: center; margin: -9px 7px -7px 0px;"
                  />{{ T__("rolling days into the future") }}
                </div>
              </label>
            </li>
            <li>
              <input
                type="radio"
                id="within-date-range"
                name="event-can-be-booked"
                value="from_to"
                v-model="form.default_availability_details.date_range_type"
                @focus="
                  form.default_availability_details.date_range_type !==
                    'from_to' &&
                    ref_click('default_availability_details_from_date_input')
                "
              />
              <label
                for="__unknown__"
                @click="
                  form.default_availability_details.date_range_type = 'from_to'
                "
              >
                <div class="txt-h5">{{ T__("Within a date range") }}</div>
                <div class="date-range-selector cf">
                  <div class="col50">
                    <div>
                      <div class="label txt-help">{{ T__("FROM") }}</div>
                      <v-date-picker
                        :locale="this.$store.getters.get_site_locale_intl"
                        v-model="default_availability_details_from_date_obj"
                        :popover="{
                          visibility: 'click'
                        }"
                        :masks="{ input: ['YYYY-MM-DD'] }"
                      >
                        <input
                          type="text"
                          readonly
                          placeholder="M d, YYYY"
                          :value="
                            $options.filters.wpcal_format_date_style1(
                              default_availability_details_from_date
                            )
                          "
                          ref="default_availability_details_from_date_input"
                        />
                        <!-- 
                          slot-scope="{ inputProps, inputEvents, hidePopover }"
                          @blur="
                            //log('at_blur_from');
                            $v.form.default_availability_details.from_date.$touch();
                            hidePopover();
                            ref_click(
                              'default_availability_details_to_date_input'
                            );
                          "
                           -->
                      </v-date-picker>
                    </div>
                  </div>
                  <div class="col50">
                    <div>
                      <div class="label txt-help">{{ T__("TO") }}</div>
                      <v-date-picker
                        :locale="this.$store.getters.get_site_locale_intl"
                        v-model="default_availability_details_to_date_obj"
                        :popover="{
                          visibility: 'click'
                        }"
                        :masks="{ input: ['YYYY-MM-DD'] }"
                        :min-date="default_availability_details_from_date_obj"
                      >
                        <input
                          type="text"
                          readonly
                          placeholder="M d, YYYY"
                          :value="
                            $options.filters.wpcal_format_date_style1(
                              default_availability_details_to_date
                            )
                          "
                          ref="default_availability_details_to_date_input"
                        />
                        <!-- @blur="
                            $v.form.default_availability_details.to_date.$touch()
                          " -->
                      </v-date-picker>
                    </div>
                  </div>
                </div>
              </label>
            </li>
            <li>
              <input
                type="radio"
                id="indefinitely"
                name="event-can-be-booked"
                value="infinite"
                v-model="form.default_availability_details.date_range_type"
              />
              <label for="indefinitely">
                <div class="txt-h5">{{ T__("Indefinitely") }}</div>
                <div class="txt-help">
                  {{
                    T__("Invitees can book slots indefinitely into the future")
                  }}
                </div>
              </label>
            </li>
          </ul>
          <form-row :validator="$v.form.default_availability_details.date_misc">
          </form-row>
          <form-row :validator="$v.form.default_availability_details.from_date">
          </form-row>
          <form-row :validator="$v.form.default_availability_details.to_date">
          </form-row>
        </form-row>
        <form-row>
          <label>{{ T__("Availability for this event type") }}</label>
          <span class="txt-help pt0">{{
            T__("Set your availability specifically for this event type.")
          }}</span>
          <div class="mbox mt10">
            <form-row
              :validator="$v.form.default_availability_details.periods"
              style="display: block; margin-bottom:-10px;"
            >
              <div class="txt-h5 caps">
                {{ T__("Available hours") }}
              </div>
              <TimeRange1ToN
                class="time-range-selector"
                v-model="form.default_availability_details.periods"
                :$v="$v.form.default_availability_details.periods"
              ></TimeRange1ToN>
            </form-row>
            <hr />
            <form-row
              style="margin-bottom: -10px; display: block;"
              :validator="$v.form.default_availability_details.day_index_list"
            >
              <div class="txt-h5 caps">
                {{ T__("Available days") }}
              </div>
              <WeekDaysSelector
                v-model="form.default_availability_details.day_index_list"
              ></WeekDaysSelector>
            </form-row>
            <button
              v-if="view == 'edit'"
              style="width: 100%;"
              type="button"
              class="wpc-btn secondary md mt20"
              @click="$emit('may-show-service-availability-modal')"
            >
              {{ T__("Set custom hours for specific days/dates") }}
            </button>
            <span v-if="view == 'add'"
              >More availability customization once event type is created.</span
            >
            <hr />
            <form-row
              :validator="$v.form.timezone"
              style="margin-bottom: -20px; display: block;"
            >
              <div class="txt-h5 caps">
                {{ T__("Time zone") }}
              </div>
              <TimeZoneSelector
                v-model="form.timezone"
                :use_as="'form_tz'"
              ></TimeZoneSelector>
            </form-row>
          </div>
        </form-row>
        <form-row :validator="$v.form.display_start_time_every">
          <label>
            {{ T__("Show start times every:") }}
            <a
              href="https://help.wpcal.io/en/article/event-type-availability-options-show-start-times-every-minimum-scheduling-notice-and-event-buffers-17lvw88/?utm_source=wpcal_plugin&utm_medium=contextual#1-how-show-start-times-every-works"
              style="float: right;"
              target="_blank"
              class="icon-q-mark"
            ></a>
          </label>
          <div class="txt-help">
            {{ T__("Show your available hours in blocks of:") }}
          </div>
          <InlineRadioSelector
            :element_settings="display_start_time_every_element_setting"
            :form="form"
            :$v="$v"
          ></InlineRadioSelector>
        </form-row>

        <a
          @click="show_advance_options = !show_advance_options"
          style="font-size:14px;"
          >{{ show_advance_options_txt }}</a
        >
        <div v-show="show_advance_options">
          <ul class="mbox avail-advanced-options">
            <li>
              <form-row :validator="$v.form.max_booking_per_day">
                <div class="txt-h5 caps">
                  {{ T__("Max bookings per day") }}
                </div>
                <div class="txt-help" style="margin-bottom:10px;">
                  {{
                    T__(
                      "Limit the number of bookings for this event type per day. Leave blank for no limit."
                    )
                  }}
                </div>
                <input
                  type="text"
                  v-model="form.max_booking_per_day"
                  placeholder="No limit"
                  @blur="$v.form.max_booking_per_day.$touch()"
                />
              </form-row>
            </li>
            <li>
              <div class="txt-h5 caps">
                {{ T__("Minimum Scheduling Notice") }}
                <a
                  href="https://help.wpcal.io/en/article/event-type-availability-options-show-start-times-every-minimum-scheduling-notice-and-event-buffers-17lvw88/?utm_source=wpcal_plugin&utm_medium=contextual#1-how-minimum-scheduling-notice-works"
                  target="_blank"
                  class="icon-q-mark"
                ></a>
              </div>
              <div class="custom-radio-cont">
                <label style="font-size: 13px;"
                  ><input
                    type="radio"
                    name="min_schedule_notice_type"
                    style="float: left; margin-right: 7px; margin-top: -1px;"
                    value="none"
                    v-model="form.min_schedule_notice.type"
                  />
                  {{ T__("None") }}
                </label>
                <label style="font-size: 13px;"
                  ><input
                    type="radio"
                    name="min_schedule_notice_type"
                    style="float: left; margin-right: 7px; margin-top: -1px; margin-bottom: 20px;"
                    value="units"
                    v-model="form.min_schedule_notice.type"
                  />
                  {{ T__("Prevent booking of slots less than") }}
                  <div style="padding-left: 22px; padding-top: 4px;">
                    <input
                      type="number"
                      style="width: 78px; padding: 3px 5px; margin-top: -8px; font-size: 13px;"
                      v-model="form.min_schedule_notice.time_units"
                      @focus="form.min_schedule_notice.type = 'units'"
                      @blur="$v.form.min_schedule_notice.time_units.$touch()"
                    />
                    <select
                      style="width: auto; margin-top: -3px;"
                      v-model="form.min_schedule_notice.time_units_in"
                      @focus="form.min_schedule_notice.type = 'units'"
                    >
                      <option value="mins">{{ T__("mins") }}</option>
                      <option value="hrs" selected>{{ T__("hrs") }}</option>
                      <option value="days">{{ T__("days") }}</option>
                    </select>
                    {{
                      T_x("away.", "Prevent booking of slots less than _ away")
                    }}
                  </div>
                  <form-row
                    :validator="$v.form.min_schedule_notice.time_units"
                  ></form-row>
                </label>
                <label style="font-size: 13px; margin-bottom: 1px;"
                  ><input
                    type="radio"
                    name="min_schedule_notice_type"
                    id="min_schedule_notice_type_time_days_before"
                    style="float: left; margin-right: 7px; margin-top: -1px;margin-bottom: 20px;"
                    value="time_days_before"
                    v-model="form.min_schedule_notice.type"
                  />
                  {{ T__("Prevent all bookings after") }}
                </label>
                <!-- <input
                    type="text"
                    placeholder="hh:mm am"
                    style="width: 78px;
    padding: 3px 5px;
    margin-top: -2px;
    font-size: 13px;"
                    v-model="form.min_schedule_notice.days_before_time"
                    @focus="form.min_schedule_notice.type = 'time_days_before'"
                    @blur="
                      $v.form.min_schedule_notice.days_before_time.$touch()
                    "
                  /> -->
                <div
                  style="display:flex; align-items: center;"
                  class="prevent-bookings-after-timepicker"
                >
                  <TimePicker
                    v-model="form.min_schedule_notice.days_before_time"
                    @time-picker-opened="
                      form.min_schedule_notice.type = 'time_days_before'
                    "
                  /><span style="margin-left: 3px;"
                    ><span v-if="time_format == 'HH:mm'">hrs</span>,</span
                  >

                  <select
                    style="width: auto; margin-left: 5px;"
                    v-model="form.min_schedule_notice.days_before"
                    @focus="form.min_schedule_notice.type = 'time_days_before'"
                  >
                    <option
                      v-for="(val, index) in [0, 1, 2, 3, 4, 5, 6, 7]"
                      :key="index"
                      :value="val"
                      >{{ val }}</option
                    >
                  </select>
                  <label
                    for="min_schedule_notice_type_time_days_before"
                    style="font-size: 13px; padding-left: 3px;"
                  >
                    {{
                      T_n(
                        "day before.",
                        "days before.",
                        form.min_schedule_notice.days_before
                      )
                    }}
                  </label>
                </div>
                <form-row
                  :validator="$v.form.min_schedule_notice.days_before_time"
                ></form-row>
              </div>
            </li>
            <li>
              <div class="txt-h5 caps">
                {{ T__("Event Buffers") }}
                <a
                  href="https://help.wpcal.io/en/article/event-type-availability-options-show-start-times-every-minimum-scheduling-notice-and-event-buffers-17lvw88/?utm_source=wpcal_plugin&utm_medium=contextual#1-how-event-buffers-works"
                  target="_blank"
                  class="icon-q-mark"
                ></a>
              </div>
              <div class="txt-help" style="margin-bottom:10px;">
                {{
                  T__(
                    "Set aside preparation, rest or travel time before or after events. For example, if you define a 5-minute buffer before your events, we will make sure you have 5 minutes of free time before your scheduled events."
                  )
                }}
              </div>
              <div class="col-main cf">
                <div class="col50">
                  <div class="label txt-help" style="padding-bottom:5px;">
                    {{ T__("BEFORE EVENT") }}
                  </div>
                  <select
                    v-model="form.event_buffer_before"
                    @change="$v.form.event_buffer_before.$touch()"
                  >
                    <option
                      :value="option.value"
                      v-for="(option,
                      index) in event_buffer_before_element_setting.options"
                      :key="index"
                      >{{ option.text }}</option
                    >
                  </select>
                </div>
                <div class="col50">
                  <div class="label txt-help" style="padding-bottom:5px;">
                    {{ T__("AFTER EVENT") }}
                  </div>
                  <select
                    v-model="form.event_buffer_after"
                    @change="$v.form.event_buffer_after.$touch()"
                    >>
                    <option
                      :value="option.value"
                      v-for="(option,
                      index) in event_buffer_after_element_setting.options"
                      :key="index"
                      >{{ option.text }}</option
                    >
                  </select>
                </div>
              </div>
              <form-row :validator="$v.form.event_buffer_before"></form-row>
              <form-row :validator="$v.form.event_buffer_after"></form-row>
            </li>
          </ul>
        </div>

        <!-- <pre
          style="resize: both; overflow: auto; border: 2px solid; padding: 20px;   width: 300px;height:50px;"
          >{{ $v.step3 }}</pre
        > -->
        <div class="wpc-form-row">
          <button
            style="margin: 10px 0;"
            v-if="view == 'add'"
            type="button"
            class="wpc-btn primary lg"
            :disabled="!create_or_update_btn_is_enabled"
            @click="$emit('validate-may-navigate-or-submit', 3)"
          >
            {{ T__("Create Event Type") }}
          </button>
          <button
            style="margin: 10px 0;"
            v-else-if="view == 'edit'"
            type="button"
            class="wpc-btn primary lg"
            :disabled="!create_or_update_btn_is_enabled"
            @click="$emit('submit-form', 3)"
          >
            {{ T__("Save") }}
          </button>
          <button
            v-if="view == 'edit'"
            type="button"
            @click="$emit('edit-view-toggle-steps')"
            class="wpc-btn tert-link sm mt10 center"
          >
            {{ T__("Cancel") }}
          </button>
          <div
            class="txt-help mt10"
            style="padding-bottom:10px;"
            v-if="view == 'add'"
          >
            {{
              T__(
                "You can configure your event type further after creating it."
              )
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InlineRadioSelector from "@/components/form_elements/InlineRadioSelector.vue";
import TimeRange1ToN from "@/components/form_elements/TimeRange1ToN.vue";
import WeekDaysSelector from "@/components/form_elements/WeekDaysSelector.vue";
import TimeZoneSelector from "@/components/form_elements/TimeZoneSelector.vue";
import TimePicker from "@/components/form_elements/TimePicker.vue";

import { debounce } from "lodash-es";

export default {
  name: "ServiceFormStep3",
  props: {
    view: {
      type: String
    },
    step: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    create_or_update_btn_is_enabled: {},
    $v: {}
  },
  components: {
    InlineRadioSelector,
    TimeRange1ToN,
    WeekDaysSelector,
    TimeZoneSelector,
    TimePicker
  },
  data() {
    return {
      show_advance_options: false,
      event_duration_element_setting: {
        name: "duration",
        options: [
          { value: 15, text: 15 },
          { value: 30, text: 30 },
          { value: 45, text: 45 },
          { value: 60, text: 60 }
        ],
        custom_option: true,
        style_class: []
      },
      display_start_time_every_element_setting: {
        name: "display_start_time_every",
        options: [
          { value: 15, text: 15 },
          { value: 30, text: 30 },
          { value: 45, text: 45 },
          { value: 60, text: 60 }
        ],
        custom_option: true,
        style_class: [] //"avail-increments"
      },
      event_buffer_before_element_setting: {
        name: "event_buffer_before",
        options: [
          { value: 0, text: "0 " + this.T_x("min", "mintue") },
          { value: 5, text: "5 " + this.T_x("min", "mintue") },
          { value: 10, text: "10 " + this.T_x("min", "mintue") },
          { value: 15, text: "15 " + this.T_x("min", "mintue") },
          { value: 30, text: "30 " + this.T_x("min", "mintue") },
          { value: 45, text: "45 " + this.T_x("min", "mintue") },
          { value: 60, text: "1 " + this.T_x("hr", "hour") },
          {
            value: 90,
            text:
              "1 " +
              this.T_x("hr", "hour") + // intentional line break, i18n search replace
              " 30 " +
              this.T_x("min", "mintue")
          },
          { value: 120, text: "2 " + this.T_x("hr", "hour") },
          { value: 150, text: "2 hr 30 " + this.T_x("min", "mintue") },
          { value: 180, text: "3 " + this.T_x("hr", "hour") }
        ],
        selected_value: 30
      },
      event_buffer_after_element_setting: {
        name: "event_buffer_after",
        options: [
          { value: 0, text: "0 " + this.T_x("min", "mintue") },
          { value: 5, text: "5 " + this.T_x("min", "mintue") },
          { value: 10, text: "10 " + this.T_x("min", "mintue") },
          { value: 15, text: "15 " + this.T_x("min", "mintue") },
          { value: 30, text: "30 " + this.T_x("min", "mintue") },
          { value: 45, text: "45 " + this.T_x("min", "mintue") },
          { value: 60, text: "1 " + this.T_x("hr", "hour") },
          {
            value: 90,
            text:
              "1 " +
              this.T_x("hr", "hour") + // intentional line break, i18n search replace
              " 30 " +
              this.T_x("min", "mintue")
          },
          { value: 120, text: "2 " + this.T_x("hr", "hour") },
          {
            value: 150,
            text:
              "2 " +
              this.T_x("hr", "hour") + // intentional line break, i18n search replace
              " 30 " +
              this.T_x("min", "mintue")
          },
          { value: 180, text: "3 " + this.T_x("hr", "hour") }
        ],
        selected_value: 30
      }
    };
  },
  computed: {
    show_advance_options_txt() {
      return this.show_advance_options
        ? this.T__("- Hide Advanced options")
        : this.T__("+ Show Advanced options");
    },
    show_relative_date_range: {
      // getter
      get: function() {
        let misc_value = this.form.default_availability_details.date_misc;
        if (
          this.form.default_availability_details.date_range_type ===
            "relative" &&
          misc_value
        ) {
          let show_misc_value = misc_value.replace(/^\+((\d)*)D$/gm, function(
            x,
            y
          ) {
            return y;
          });
          return show_misc_value;
        }
        return "";
      },
      // setter
      set: function(new_value) {
        new_value = new_value.trim();
        if (new_value.length > 0) {
          this.form.default_availability_details.date_misc =
            "+" + new_value + "D";
        } else {
          this.form.default_availability_details.date_misc = "";
        }
      }
    },
    default_availability_details_from_date_obj: {
      get: function() {
        if (this.default_availability_details_from_date) {
          let parsed_date = this.date_parse(
            this.default_availability_details_from_date
          );
          return parsed_date;
        }
        return "";
      },
      set: function(new_value) {
        if (
          this.form.default_availability_details.date_range_type == "from_to"
        ) {
          this.form.default_availability_details.from_date = this.$options.filters.wpcal_format_std_date(
            new_value
          );
        }
      }
    },
    default_availability_details_to_date_obj: {
      get: function() {
        if (this.default_availability_details_to_date) {
          let parsed_date = this.date_parse(
            this.default_availability_details_to_date
          );
          return parsed_date;
        }
        return "";
      },
      set: function(new_value) {
        if (
          this.form.default_availability_details.date_range_type == "from_to"
        ) {
          this.form.default_availability_details.to_date = this.$options.filters.wpcal_format_std_date(
            new_value
          );
        }
      }
    },
    default_availability_details_from_date: {
      get: function() {
        return this.form.default_availability_details.date_range_type ==
          "from_to"
          ? this.form.default_availability_details.from_date
          : "";
      },
      set: debounce(function(new_value) {
        this.form.default_availability_details.from_date = new_value;
      }, 1500)
    },
    default_availability_details_to_date: {
      get: function() {
        return this.form.default_availability_details.date_range_type ==
          "from_to"
          ? this.form.default_availability_details.to_date
          : "";
      },
      set: debounce(function(new_value) {
        this.form.default_availability_details.to_date = new_value;
      }, 1500)
    }
  },
  mounted() {
    this.$root.$on("show-advance-options", () => {
      this.show_advance_options = true;
    });
  }
};
</script>

<style lang="css" scoped>
.custom-radio-cont label {
  display: block;
  margin-bottom: 10px;
}
.custom-radio-cont label:last-child {
  margin-bottom: 0;
}
.on-boarding-change-avail {
  content: "";
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 269.32 57.98'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23131336;%7D%3C/style%3E%3C/defs%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M58.15,16.28c-.19.49-1.63,2.13-4.71,5.22A10.73,10.73,0,0,1,53.63,23c0,.3,0,.64.06,1s0,.87.05,1.53a24.41,24.41,0,0,0,.4,2.76c0,.23.31.57.33.89a.56.56,0,0,1-.58.59.72.72,0,0,1-.76-.72c0-.13,0-.19,0-.36,0-.49-.34-1.4-.54-3.32-.13-1.3-.29-2.69-.29-2.69a1.8,1.8,0,0,1-.52-.28,16.77,16.77,0,0,0-2-4.16c-.57-.77-1.1-.43-1.14-1,0-.3.19-.45.48-.47a1.84,1.84,0,0,1,1.51.77,24,24,0,0,1,1.77,3.3,37.2,37.2,0,0,0,4.91-5.08c.15-.22.41-.81.83-.84.24,0,.66.23.68.52S58.23,16.08,58.15,16.28Z'/%3E%3Cpath class='cls-1' d='M58.57,28.49c-1.34.1-2.16-1.47-2.25-2.71a3.5,3.5,0,0,1,.21-1.51c.87-2.48,1.89-3.56,3-3.64a2.82,2.82,0,0,1,2.75,2.53c0,.22.06.41.08.61A4.58,4.58,0,0,1,58.57,28.49Zm-1.18-3.55a2.26,2.26,0,0,0,0,.75c0,.67.5,1.87,1.36,1.81A3.63,3.63,0,0,0,61,25.6a4.34,4.34,0,0,0,.4-2c-.06-.83-.6-2-1.64-1.93C59.6,21.71,58.14,22,57.39,24.94Z'/%3E%3Cpath class='cls-1' d='M66.75,27.58a1.42,1.42,0,0,1-.57.19c-2.23.17-2.79-6.57-2.86-7.27,0-.45.12-.62.33-.63h.1c.41,0,.6.43.62.67s0,.51,0,.76c.23,3,1.07,5.36,1.71,5.31.11,0,.24-.11.35-.35a15.25,15.25,0,0,0,.9-5.29c0-.27,0-.68.55-.73s.58.72.58.72C68.52,21.3,67.84,27,66.75,27.58Z'/%3E%3Cpath class='cls-1' d='M86.67,22.85c0,.17-4.46,3.8-7.53,4a2.12,2.12,0,0,1-2.5-1.76c-.17-2.19,2.43-5.68,4.06-6.05A1.92,1.92,0,0,1,81,19c.45,0,.65.15.67.41s-.33.93-.69,1c-.18,0-.4-.06-.63-.05a.66.66,0,0,0-.15,0c-.42.17-2.68,2.86-2.56,4.5A1.28,1.28,0,0,0,79.2,26c2.38-.17,6.66-3.47,6.87-3.56a.49.49,0,0,1,.16-.05.41.41,0,0,1,.43.38Z'/%3E%3Cpath class='cls-1' d='M91.35,25.87c0,.06-.13.09-.22.1a.56.56,0,0,1-.41-.12,1.15,1.15,0,0,1-.2-.43,5.31,5.31,0,0,1-2.44,1.13,1.38,1.38,0,0,1-1.6-1.37c-.09-1.27.89-3.07,2.34-3.17,1-.08,1.58.81,1.93,1.65a4.68,4.68,0,0,0,.17-1.74c-.08-1.09-.63-3.17-2.12-3.06-.76.06-1.45.62-1.47.89,0,.07,0,.1-.15.1a.53.53,0,0,1-.58-.43c0-.64,1.13-1.37,2.22-1.45a2,2,0,0,1,1.08.18,4.24,4.24,0,0,1,2,3.67A10.27,10.27,0,0,1,91.35,25.87ZM89,22.94A2,2,0,0,0,87.36,25c0,.42.22.67.69.64a4.65,4.65,0,0,0,2.11-1.22S89.57,22.9,89,22.94Z'/%3E%3Cpath class='cls-1' d='M99.21,26.33a.89.89,0,0,1-.91-.79c0-.13,0-.25,0-.43,0-.4-.29-1.27-.41-3l-.12-1.83c0-.22-.15-1.75-.38-1.73s-1.54,2.73-2.22,5.09c-.45,1.57-.39,2.06-.6,2.25a1.17,1.17,0,0,1-.36.12.53.53,0,0,1-.43-.2,1.38,1.38,0,0,1-.16-.61c0-.61,0-1.71-.13-3.75a31.43,31.43,0,0,1,0-3.41c0-.32.19-.45.38-.46a.8.8,0,0,1,.62.25.49.49,0,0,1,.1.32c0,.41-.1,1.14,0,2.24,0,.54,0,.77,0,1,0,.09,0,.21,0,.36,0,0,1.67-4.49,2.84-4.58h.08c.89.12,1.12,1.87,1.3,4.32l.17,2.16a7.14,7.14,0,0,0,.14,1.23,2.27,2.27,0,0,1,.39.9A.44.44,0,0,1,99.21,26.33Z'/%3E%3Cpath class='cls-1' d='M117.27,20.56c0,.17-4.45,3.81-7.53,4a2.14,2.14,0,0,1-2.5-1.77c-.16-2.19,2.44-5.68,4.06-6a2,2,0,0,1,.32,0c.45,0,.66.14.67.4s-.32.94-.68,1c-.19,0-.4-.06-.63,0a.33.33,0,0,0-.15,0c-.42.16-2.69,2.85-2.57,4.49a1.3,1.3,0,0,0,1.55,1.14c2.37-.18,6.66-3.48,6.86-3.57l.17,0a.43.43,0,0,1,.43.39Z'/%3E%3Cpath class='cls-1' d='M124.18,22.36c0,.3.07.56.09.75s0,.44-.48.47-.61-.35-.65-.84,0-1.17-.09-2.19c-.1-1.42-.36-3.06-.79-3.3a.52.52,0,0,0-.31-.05c-1.13.08-3.32,2.56-3.76,3.73a5.48,5.48,0,0,0-.32,2.32c0,.21.07.41.09.64.05.69-.31.93-.65,1a.62.62,0,0,1-.69-.58,2,2,0,0,1,.19-.81c.17-.45-.23-2.73-.06-7.43.1-3.13-.19-4.74.47-4.79.49,0,.68.2.71.63,0,.58-.16,1.58-.19,3.07s0,3.15,0,4.87c0,0,2.29-3.51,4.25-3.66a1.83,1.83,0,0,1,.52,0c1,.28,1.42,2.28,1.57,4.19C124.13,21,124.13,21.81,124.18,22.36Z'/%3E%3Cpath class='cls-1' d='M130.1,23c0,.06-.13.08-.22.09a.53.53,0,0,1-.41-.12,1.06,1.06,0,0,1-.2-.42,5.42,5.42,0,0,1-2.44,1.13,1.38,1.38,0,0,1-1.6-1.38c-.09-1.26.89-3.06,2.35-3.17,1-.08,1.57.81,1.92,1.66a4.68,4.68,0,0,0,.17-1.74c-.08-1.09-.63-3.18-2.12-3.06-.76,0-1.45.62-1.47.88,0,.08,0,.1-.14.11a.54.54,0,0,1-.59-.43c0-.64,1.13-1.38,2.23-1.46a1.9,1.9,0,0,1,1.07.19,4.21,4.21,0,0,1,2,3.66A10.34,10.34,0,0,1,130.1,23Zm-2.4-2.93a2,2,0,0,0-1.59,2.09c0,.41.22.67.7.63a4.66,4.66,0,0,0,2.1-1.22S128.32,20,127.7,20.05Z'/%3E%3Cpath class='cls-1' d='M138,23.43a.88.88,0,0,1-.92-.78c0-.13,0-.25,0-.44a29.83,29.83,0,0,1-.41-3l-.12-1.83c0-.23-.15-1.75-.38-1.74s-1.54,2.73-2.21,5.1c-.45,1.57-.4,2-.61,2.24a.91.91,0,0,1-.35.12.53.53,0,0,1-.44-.19,1.32,1.32,0,0,1-.15-.62c0-.6,0-1.7-.13-3.74a29.82,29.82,0,0,1,0-3.41c0-.33.19-.45.38-.47a.83.83,0,0,1,.63.26.56.56,0,0,1,.1.31c0,.42-.11,1.15,0,2.24.05.55,0,.78,0,1a3.37,3.37,0,0,0,.05.36s1.67-4.48,2.84-4.57h.08c.9.12,1.12,1.87,1.31,4.32l.16,2.17A5.74,5.74,0,0,0,138,22a2.57,2.57,0,0,1,.39.9A.45.45,0,0,1,138,23.43Z'/%3E%3Cpath class='cls-1' d='M151.68,23c-.75.05-.66-.2-.89-.45,0,0-.28,0-.71,0a21.63,21.63,0,0,0-3.15.48,3.82,3.82,0,0,1,.4,1.6,9.45,9.45,0,0,1-.87,4.37c-.62,1.5-2.29,3.56-4.48,3.72a3.6,3.6,0,0,1-3.9-3.08,4.34,4.34,0,0,1,1-3c2.06-2.61,3.75-3.31,6.4-4.15a3,3,0,0,0-2.4-1.24,3.21,3.21,0,0,0-.55,0,10.17,10.17,0,0,0-2.73.83c-.24,0-.61-.15-.64-.43s.45-.6.8-.74a3,3,0,0,1-.3-1.06c-.08-1,.69-1.85,1.86-3.49,0,0-.55-.27-.57-.55s.11-.5.38-.52a.62.62,0,0,1,.38.14,1.13,1.13,0,0,0,.42,0c1.06-.08,3.65-.73,4.72-.81a2.09,2.09,0,0,1,.38,0c.25.06.47.17.48.34a.41.41,0,0,1-.33.41c-.13,0-.36,0-.72,0-.79.06-1.6.37-2.55.55a2.59,2.59,0,0,1,1.11,1.72c.08,1.06-.66,1.79-1.59,2.64a4,4,0,0,1,1.35.53,4.33,4.33,0,0,1,1.45,1.35s1.72-.32,3-.42,2.68-.12,3.08.55a.33.33,0,0,1,0,.13C152.63,22.83,152.13,23,151.68,23Zm-5.72.35a11,11,0,0,0-6,3.84,3.88,3.88,0,0,0-.9,2.42,2.64,2.64,0,0,0,2.8,2.14,4.61,4.61,0,0,0,3.36-2.45A8,8,0,0,0,146.39,25,5.08,5.08,0,0,0,146,23.37Zm-3.15-6.95c-1.64,1.69-2.12,3.06-2.09,3.51a2.52,2.52,0,0,0,.21.74,9,9,0,0,0,1.29-.47c.78-.4,2.21-1.38,2.14-2.32A1.71,1.71,0,0,0,142.81,16.42Z'/%3E%3Cpath class='cls-1' d='M156.41,18.19c-.4.26-3.23,3.26-5.36,3.41a1.93,1.93,0,0,1-.84-.1,4,4,0,0,1-2.36-3.3,3.13,3.13,0,0,1,0-.68c.33-2.17,2.65-3.8,4.63-3.95a2.84,2.84,0,0,1,1.66.31.14.14,0,0,1,.08.13c0,.47-1.47,1.8-2.5,2.52A6.35,6.35,0,0,1,149,17.61a2.46,2.46,0,0,0,0,.55,3,3,0,0,0,.63,1.58,1.67,1.67,0,0,0,1.6.89c1.49-.11,4.24-2.73,4.41-3s.26-.73.58-.75a.61.61,0,0,1,.61.56A1,1,0,0,1,156.41,18.19Zm-5.62-3.05a5,5,0,0,0-1.45,1.38,5.36,5.36,0,0,0,2.17-.94,7.15,7.15,0,0,0,1.32-1.12A4.38,4.38,0,0,0,150.79,15.14Z'/%3E%3Cpath class='cls-1' d='M170.5,15c-.05,1.07-.12,5.42-.25,8.57-.09,2.32-.23,3.55-.2,3.94,0,.08,0,.12,0,.13a1.55,1.55,0,0,1,.32.74c0,.28-.15.52-.64.56s-.78-.25-.8-.55a.85.85,0,0,1,.18-.62,43.49,43.49,0,0,0,.29-6.05c.07-2.6.1-4-.05-6.82,0,0-3,4.39-4.11,4.46-.41,0-.58-.45-.64-1.19a32.1,32.1,0,0,1,.2-4.24c0-.23-.06-1.78.51-1.82a.8.8,0,0,1,.68.54c0,1.55-.53,3.09-.4,4.71,0,.11,0,.32.17.31.47,0,1.88-2,3.27-3.9.23-.32.26-.91.65-.94a.4.4,0,0,1,.21,0c.31.09.52.83.58,1.55Q170.52,14.7,170.5,15Z'/%3E%3Cpath class='cls-1' d='M174.09,19.86c-1.34.1-2.16-1.46-2.25-2.71a3.5,3.5,0,0,1,.21-1.51c.88-2.48,1.9-3.56,3-3.64a2.82,2.82,0,0,1,2.75,2.53c0,.22.06.41.08.62A4.57,4.57,0,0,1,174.09,19.86Zm-1.18-3.55a2.58,2.58,0,0,0,0,.75c0,.67.5,1.87,1.36,1.81a3.63,3.63,0,0,0,2.29-1.9,4.34,4.34,0,0,0,.4-2c-.06-.83-.6-2-1.64-1.93C175.12,13.08,173.66,13.39,172.91,16.31Z'/%3E%3Cpath class='cls-1' d='M182.27,19a1.42,1.42,0,0,1-.57.19c-2.23.17-2.79-6.57-2.86-7.27,0-.45.12-.62.33-.63h.1c.41,0,.6.43.62.68s0,.51,0,.75c.23,3,1.07,5.36,1.71,5.31.11,0,.24-.11.35-.35a14.94,14.94,0,0,0,.89-5.29c0-.27,0-.68.56-.73s.58.72.58.72C184,12.68,183.36,18.34,182.27,19Z'/%3E%3Cpath class='cls-1' d='M192.4,11.35c-.25,0-.47-.14-.77-.11a1,1,0,0,0-.48.18,14.65,14.65,0,0,0-3.65,4.66c-.62,1.1-.27,2.54-.49,2.88a.49.49,0,0,1-.4.23.64.64,0,0,1-.71-.7c-.05-.57.11-1.54.07-3,0-.49,0-.91-.05-1.29a7.44,7.44,0,0,0-.64-2.94c0-.21.34-.47.53-.48a.64.64,0,0,1,.43.16c.3.24.39.67.52,1.82.06.65.09,1,.19,2.28a25.13,25.13,0,0,1,2.29-3,4,4,0,0,1,2.49-1.72,2.56,2.56,0,0,1,.88.09.59.59,0,0,1,.3.47A.54.54,0,0,1,192.4,11.35Z'/%3E%3Cpath class='cls-1' d='M205.23,17.37c0,.06-.13.08-.22.09a.56.56,0,0,1-.41-.12,1.12,1.12,0,0,1-.2-.42A5.42,5.42,0,0,1,202,18.05a1.39,1.39,0,0,1-1.6-1.38c-.09-1.26.89-3.06,2.34-3.17,1-.08,1.58.81,1.93,1.66a4.68,4.68,0,0,0,.17-1.74c-.08-1.1-.63-3.18-2.12-3.07-.76.06-1.45.62-1.47.89,0,.08-.05.1-.15.11a.54.54,0,0,1-.58-.43c0-.65,1.13-1.38,2.22-1.46a1.94,1.94,0,0,1,1.08.19,4.21,4.21,0,0,1,2,3.66A10.38,10.38,0,0,1,205.23,17.37Zm-2.4-2.93a2,2,0,0,0-1.59,2.09c0,.41.22.66.69.63A4.65,4.65,0,0,0,204,15.94S203.45,14.39,202.83,14.44Z'/%3E%3Cpath class='cls-1' d='M214.21,9.66a46.45,46.45,0,0,0-3.87,6.55c-.14.41-.45,1.06-.91,1.09a.69.69,0,0,1-.26-.06c-.42-.17-.56-.85-.71-1.23-.59-1.65-1-3.28-1.26-3.76a6.47,6.47,0,0,1-.56-1.45.35.35,0,0,1,.33-.39c.39,0,.91.58,1.22,1.43s.28,1.17.69,2.41c.12.35.23.74.46,1.33,0,0,1-1.74,2-3.43s2.41-3.73,2.46-3.92.34-1,.74-1,.52.36.54.64A2.66,2.66,0,0,1,214.21,9.66Z'/%3E%3Cpath class='cls-1' d='M219.88,16.27c0,.06-.13.09-.22.1a.58.58,0,0,1-.41-.13,1.06,1.06,0,0,1-.2-.42A5.31,5.31,0,0,1,216.62,17,1.39,1.39,0,0,1,215,15.57c-.09-1.26.89-3.06,2.35-3.17,1-.07,1.57.82,1.92,1.66a4.68,4.68,0,0,0,.17-1.74c-.08-1.09-.63-3.17-2.12-3.06-.75.06-1.45.62-1.47.89,0,.07-.05.1-.14.1a.53.53,0,0,1-.59-.43c0-.64,1.13-1.37,2.23-1.45a2,2,0,0,1,1.07.18,4.22,4.22,0,0,1,2,3.67A10.31,10.31,0,0,1,219.88,16.27Zm-2.4-2.93a2,2,0,0,0-1.59,2.09c0,.42.23.67.7.63a4.58,4.58,0,0,0,2.1-1.21S218.1,13.3,217.48,13.34Z'/%3E%3Cpath class='cls-1' d='M223.11,2.87a7.62,7.62,0,0,1-.42,1.21c-.23.72-.08,1-.25,1.23a.49.49,0,0,1-.33.2c-.28,0-.37-.35-.39-.62A3.15,3.15,0,0,1,222,3.61c.34-.84.15-1.27.64-1.3a.49.49,0,0,1,.51.49Zm.32,10.92,0,.36c.06.85.29.87.32,1.21s-.09.63-.47.66a.81.81,0,0,1-.46-.14c-.18-.12-.27-.53-.32-1.21-.07-.9-.07-2.27-.11-4.08,0-1.05-.18-2.11.48-2.2a.64.64,0,0,1,.63.67C223.58,9.7,223.38,13.05,223.43,13.79Z'/%3E%3Cpath class='cls-1' d='M227.75,8.86a39.12,39.12,0,0,0,.06,5.12c0,.6.15,1.27.2,1.91,0,.42,0,1-.38,1a.74.74,0,0,1-.47-.14c-.16-.08-.28-.68-.34-1.53-.17-2.24-.07-6.32,0-8.64s0-4.09.21-4.32a.7.7,0,0,1,.4-.26c.13,0,.28.06.49.25a.75.75,0,0,1,.19.5C228.14,3.41,227.92,4.87,227.75,8.86Z'/%3E%3Cpath class='cls-1' d='M234.65,15.17a.27.27,0,0,1-.22.09.5.5,0,0,1-.41-.12,1.06,1.06,0,0,1-.2-.42,5.42,5.42,0,0,1-2.44,1.13,1.38,1.38,0,0,1-1.6-1.38c-.1-1.26.89-3.06,2.34-3.17,1-.08,1.58.81,1.92,1.66a4.8,4.8,0,0,0,.18-1.74c-.08-1.09-.64-3.17-2.13-3.06-.75.05-1.45.62-1.46.88,0,.08,0,.1-.15.11a.52.52,0,0,1-.58-.43c-.05-.64,1.13-1.37,2.22-1.46a1.94,1.94,0,0,1,1.08.19,4.21,4.21,0,0,1,2,3.66A10.34,10.34,0,0,1,234.65,15.17Zm-2.4-2.93a2,2,0,0,0-1.59,2.09c0,.42.22.67.69.63a4.65,4.65,0,0,0,2.11-1.22S232.87,12.19,232.25,12.24Z'/%3E%3Cpath class='cls-1' d='M239,15c-.26.3-.23.49-.47.51a.67.67,0,0,1-.71-.58,1.25,1.25,0,0,1,0-.21h0c-.13,0-.53,0-.68-.24a7.68,7.68,0,0,1-.1-1,40,40,0,0,1-.08-4.72s-.25-.06-.34-.5c0-.21.23-.48.5-.63a18.78,18.78,0,0,0,.35-4c0-.22-.2-.59-.22-.91a.43.43,0,0,1,.43-.51c.34,0,.78.57.85,1.46a21,21,0,0,1-.39,3.69l.25,0c.79-.06,3.46-.13,4.42,1.66a1.12,1.12,0,0,1,.13.44C243.06,11.3,239.36,14.59,239,15Zm2.7-5.74c-.41-.71-1.89-1-3.12-.91a5.4,5.4,0,0,0-.6.09,15.52,15.52,0,0,0-.19,2.57c0,.32,0,.64.05.93a15.15,15.15,0,0,0,.36,2.41s3.75-3,3.62-4.7A1,1,0,0,0,241.73,9.22Z'/%3E%3Cpath class='cls-1' d='M245.34,1.21a7.62,7.62,0,0,1-.42,1.21c-.23.72-.07,1-.25,1.23a.5.5,0,0,1-.33.2c-.28,0-.36-.35-.38-.62A3,3,0,0,1,244.18,2c.34-.85.16-1.27.65-1.3a.5.5,0,0,1,.51.49Zm.33,10.92,0,.36c.06.85.29.87.32,1.21s-.09.63-.46.66a.84.84,0,0,1-.47-.14c-.18-.12-.27-.53-.32-1.21-.06-.9-.07-2.27-.11-4.09,0-1-.18-2.11.48-2.19.32,0,.6.24.64.67C245.81,8,245.61,11.39,245.67,12.13Z'/%3E%3Cpath class='cls-1' d='M250,7.2a42.76,42.76,0,0,0,.06,5.11c.05.61.15,1.28.2,1.92,0,.42,0,1-.38,1a.74.74,0,0,1-.47-.14c-.15-.08-.27-.68-.34-1.53-.16-2.24-.07-6.32,0-8.64s0-4.09.21-4.32a.7.7,0,0,1,.4-.26.69.69,0,0,1,.49.25.73.73,0,0,1,.19.5C250.37,1.75,250.16,3.21,250,7.2Z'/%3E%3Cpath class='cls-1' d='M253.77.58a7.62,7.62,0,0,1-.42,1.21c-.23.72-.08,1-.25,1.23a.5.5,0,0,1-.33.2c-.28,0-.36-.35-.38-.62a3,3,0,0,1,.22-1.28c.34-.84.16-1.27.65-1.3a.5.5,0,0,1,.51.49Zm.32,10.92,0,.36c.06.85.29.87.32,1.21s-.09.63-.46.66a.82.82,0,0,1-.47-.14c-.18-.12-.27-.53-.32-1.21-.06-.9-.07-2.27-.11-4.08,0-1.05-.18-2.12.48-2.2.32,0,.6.24.64.67C254.24,7.41,254,10.76,254.09,11.5Z'/%3E%3Cpath class='cls-1' d='M269.31,7.61c-.05,1.07-.12,5.42-.25,8.57-.09,2.32-.23,3.55-.2,3.94,0,.08,0,.11,0,.13a1.51,1.51,0,0,1,.32.74c0,.28-.15.52-.64.56s-.78-.25-.8-.55a.85.85,0,0,1,.18-.62,43.49,43.49,0,0,0,.29-6c.07-2.6.1-4-.05-6.82,0,0-3,4.39-4.11,4.46-.41,0-.58-.45-.64-1.19a38.26,38.26,0,0,1,.2-4.24c0-.46,0-.84.07-1.14a2.79,2.79,0,0,0-.61,0A14.64,14.64,0,0,0,260,6a56.22,56.22,0,0,0,0,5.8,8.44,8.44,0,0,0,.09.92,4,4,0,0,1,.13.56.39.39,0,0,1-.42.48h-.07c-.57,0-.72-.69-.74-1a34.52,34.52,0,0,1-.09-4c0-1.35.08-1.74.12-2.55a9.14,9.14,0,0,0-1.57.64c-.31.18-.9.81-1.24.84s-.61-.24-.63-.51a.45.45,0,0,1,0-.11c.08-.29.1-.45,1.11-.92a17.39,17.39,0,0,1,2.39-1s.15-1.57.18-3.66V1.5c0-.21-.07-.47-.09-.73s0-.74.38-.77.61.32.68,1.31a8.35,8.35,0,0,1,0,1c0,1.14-.11,1.45-.19,2.69a14.47,14.47,0,0,1,2.54-.44l.51,0c.36,0,1.65,0,1.72.69,0,.45-.49,3.58-.41,4.65,0,.19,0,.32.1.35s0,0,.08,0c.47,0,1.88-2,3.27-3.91.23-.31.26-.91.66-.93a.4.4,0,0,1,.21,0c.3.09.51.83.57,1.55C269.32,7.21,269.32,7.42,269.31,7.61Z'/%3E%3Cpath class='cls-1' d='M57.54,39.06c-.27,0-.37-.12-.68-.21a2.14,2.14,0,0,0-.79-.1c-1.77.13-2.28,3-2,6.2,0,.32.09.64.12,1.07,1.76-.37,2.55-.2,2.85-.45a.42.42,0,0,1,.29-.12A.63.63,0,0,1,58,46c0,.51-.47.59-.82.63a26.21,26.21,0,0,0-2.92.35,35,35,0,0,1,.11,5c-.19,2.55-.58,4.59-.55,5.08a.85.85,0,0,1,0,.23.63.63,0,0,1-.58.67c-.36,0-.71-.12-.74-.55a.93.93,0,0,1,.17-.57,20.63,20.63,0,0,0,.61-4.72,31.42,31.42,0,0,0-.08-4.83,1.3,1.3,0,0,0-1,.83.65.65,0,0,1-.47.32.67.67,0,0,1-.69-.59.57.57,0,0,1,.16-.41,3.31,3.31,0,0,1,2-1.17c0-.32,0-.68-.06-1.08-.44-5.86,1.41-7.25,3-7.37.43,0,1.75,0,1.8.76A.39.39,0,0,1,57.54,39.06Z'/%3E%3Cpath class='cls-1' d='M60.07,51.14c-1.34.1-2.16-1.47-2.25-2.72A3.52,3.52,0,0,1,58,46.91c.88-2.47,1.9-3.55,3-3.64a2.82,2.82,0,0,1,2.75,2.53c0,.22.07.41.08.62A4.58,4.58,0,0,1,60.07,51.14ZM58.9,47.58a2.27,2.27,0,0,0-.06.75c0,.68.5,1.88,1.37,1.81a3.62,3.62,0,0,0,2.28-1.89,4.28,4.28,0,0,0,.4-2c-.06-.83-.6-2-1.64-1.92C61.1,44.35,59.65,44.67,58.9,47.58Z'/%3E%3Cpath class='cls-1' d='M71.93,43.1c-.25,0-.47-.13-.77-.11a1,1,0,0,0-.48.19A14.47,14.47,0,0,0,67,47.83c-.62,1.11-.27,2.54-.49,2.88a.48.48,0,0,1-.4.24.78.78,0,0,1-.52-.19.72.72,0,0,1-.19-.52c0-.56.11-1.54.08-3,0-.49,0-.91-.06-1.28a7.54,7.54,0,0,0-.64-3c0-.21.35-.46.54-.48a.62.62,0,0,1,.42.16c.31.24.4.67.52,1.82.07.66.09,1,.19,2.28a25.39,25.39,0,0,1,2.29-3A4,4,0,0,1,71.26,42a2.53,2.53,0,0,1,.88.08.58.58,0,0,1,.3.47A.53.53,0,0,1,71.93,43.1Z'/%3E%3Cpath class='cls-1' d='M86.87,41.36c-.22,0-.49,0-.64,0a16,16,0,0,0-3.12.65,56.29,56.29,0,0,0,0,5.8c0,.32.05.64.09.93,0,.07.11.33.13.55a.4.4,0,0,1-.42.49h-.07c-.57,0-.72-.69-.74-1a34.63,34.63,0,0,1-.09-4c0-1.35.08-1.73.12-2.55a9.6,9.6,0,0,0-1.57.65c-.31.18-.9.81-1.24.83a.7.7,0,0,1-.63-.5.66.66,0,0,1,0-.13c.07-.29.1-.43,1.11-.9a16.23,16.23,0,0,1,2.39-1s.23-3,.18-3.66c0-.32-.08-.58-.1-.84s0-.74.38-.77.61.31.69,1.31c0,.29,0,.63,0,1,0,1.14-.11,1.45-.19,2.69a13,13,0,0,1,2.45-.43c.17,0,.34,0,.51,0,.4,0,1.07-.08,1.15.45C87.32,41.27,87.12,41.34,86.87,41.36Z'/%3E%3Cpath class='cls-1' d='M95,47.3c0,.3.08.56.09.75s0,.44-.47.47-.62-.35-.65-.84,0-1.18-.09-2.19c-.11-1.42-.36-3.07-.8-3.3a.51.51,0,0,0-.31,0c-1.13.08-3.31,2.56-3.75,3.73a5.48,5.48,0,0,0-.32,2.32c0,.2.06.41.08.63.05.7-.31.94-.65,1a.61.61,0,0,1-.69-.57,2.33,2.33,0,0,1,.19-.81c.18-.45-.22-2.73-.06-7.43.11-3.13-.18-4.74.47-4.79.49,0,.68.19.72.63s-.17,1.58-.19,3.06,0,3.15,0,4.88c0,0,2.3-3.51,4.26-3.66a1.47,1.47,0,0,1,.51,0c1,.28,1.43,2.28,1.57,4.18C94.92,46,94.92,46.75,95,47.3Z'/%3E%3Cpath class='cls-1' d='M97.72,35a8,8,0,0,1-.42,1.2c-.23.72-.08,1-.25,1.24a.49.49,0,0,1-.33.19c-.28,0-.36-.35-.38-.61a3,3,0,0,1,.22-1.29c.34-.84.15-1.26.64-1.3a.5.5,0,0,1,.52.49ZM98,45.91l0,.36c.06.85.29.87.32,1.21s-.09.63-.47.66a.81.81,0,0,1-.46-.14c-.18-.12-.27-.53-.32-1.21-.07-.9-.07-2.27-.11-4.08,0-1-.18-2.11.48-2.2a.64.64,0,0,1,.63.67C98.19,41.82,98,45.18,98,45.91Z'/%3E%3Cpath class='cls-1' d='M104.84,39.11c-.36,0-.59-.18-.74-.17-.64.06-.82.48-2.21,1.93a3.83,3.83,0,0,0-1.13,2.53c.08,1.09,1.35,1.37,2.63,1.75s2.27.48,2.36,1.65c.06.77-2.91,2.62-3.2,2.64s-.69-.19-.71-.46a.43.43,0,0,1,.09-.29c.1-.19,2.76-1.32,2.71-2-.33-.9-4.65-.39-4.86-3.22-.16-2.07,2.08-4,3.25-5.15a1.24,1.24,0,0,1,.75-.33,1,1,0,0,1,.44.07c.26.09.94.38,1,.61v.07C105.22,38.93,105.12,39.09,104.84,39.11Z'/%3E%3Cpath class='cls-1' d='M121.93,43.52c-.4.26-3.23,3.26-5.36,3.42a2.09,2.09,0,0,1-.84-.11,4,4,0,0,1-2.35-3.3,2.6,2.6,0,0,1,0-.68c.33-2.17,2.66-3.8,4.64-4a2.9,2.9,0,0,1,1.65.31.14.14,0,0,1,.08.13c0,.47-1.47,1.8-2.5,2.52a6.3,6.3,0,0,1-2.78,1.08,2.46,2.46,0,0,0,0,.55,3,3,0,0,0,.63,1.58,1.67,1.67,0,0,0,1.6.89c1.49-.11,4.24-2.73,4.41-3s.27-.72.59-.75a.62.62,0,0,1,.61.56A1,1,0,0,1,121.93,43.52Zm-5.62-3.05a5,5,0,0,0-1.45,1.38,5.36,5.36,0,0,0,2.17-.94,7.15,7.15,0,0,0,1.32-1.12A4.38,4.38,0,0,0,116.31,40.47Z'/%3E%3Cpath class='cls-1' d='M130.17,38.7a46.77,46.77,0,0,0-3.87,6.54c-.14.41-.45,1.06-.9,1.09a.71.71,0,0,1-.27,0c-.41-.18-.56-.85-.7-1.24-.6-1.64-1-3.28-1.27-3.75a6.54,6.54,0,0,1-.56-1.46.34.34,0,0,1,.33-.38c.4,0,.92.57,1.23,1.42s.27,1.17.69,2.41c.12.35.23.75.46,1.33,0,0,1-1.74,2-3.43s2.41-3.72,2.45-3.92.35-1,.74-1,.52.36.54.64A2.6,2.6,0,0,1,130.17,38.7Z'/%3E%3Cpath class='cls-1' d='M138.84,42.26c-.4.25-3.22,3.25-5.36,3.41a2,2,0,0,1-.84-.11,4,4,0,0,1-2.35-3.29,3.1,3.1,0,0,1,0-.68c.33-2.17,2.65-3.8,4.63-4a2.81,2.81,0,0,1,1.65.31.14.14,0,0,1,.09.13c0,.47-1.48,1.79-2.5,2.52a6.33,6.33,0,0,1-2.79,1.08,2.2,2.2,0,0,0,0,.55,3,3,0,0,0,.63,1.58,1.65,1.65,0,0,0,1.6.88c1.49-.11,4.23-2.72,4.4-3s.27-.72.59-.74a.62.62,0,0,1,.61.56A1,1,0,0,1,138.84,42.26Zm-5.61-3a4.84,4.84,0,0,0-1.45,1.38,5.29,5.29,0,0,0,2.16-.94,6.59,6.59,0,0,0,1.32-1.13A4.51,4.51,0,0,0,133.23,39.21Z'/%3E%3Cpath class='cls-1' d='M145.69,45.61a.88.88,0,0,1-.91-.78c0-.13,0-.25,0-.44,0-.4-.28-1.27-.41-3l-.11-1.83c0-.23-.15-1.76-.38-1.74s-1.54,2.73-2.22,5.1c-.45,1.56-.39,2-.61,2.24a1.11,1.11,0,0,1-.35.12.52.52,0,0,1-.43-.19,1.34,1.34,0,0,1-.16-.62c0-.6,0-1.7-.13-3.74-.09-1.78,0-3.15,0-3.41s.2-.45.39-.47a.81.81,0,0,1,.62.26.49.49,0,0,1,.1.31c0,.42-.1,1.15,0,2.24,0,.55,0,.78,0,1a3,3,0,0,0,0,.36s1.68-4.49,2.85-4.57h.07c.9.12,1.13,1.87,1.31,4.32l.16,2.17a6.59,6.59,0,0,0,.15,1.22,2.33,2.33,0,0,1,.39.9A.44.44,0,0,1,145.69,45.61Z'/%3E%3Cpath class='cls-1' d='M154.14,36.34c-.23,0-.5,0-.65,0a15.71,15.71,0,0,0-3.11.65,52.26,52.26,0,0,0,0,5.8c0,.32.05.64.09.92,0,.08.12.33.14.56a.41.41,0,0,1-.42.49h-.08c-.57,0-.71-.68-.74-1a32.72,32.72,0,0,1-.08-3.95c0-1.35.08-1.73.11-2.55a9.29,9.29,0,0,0-1.56.65c-.31.17-.91.8-1.25.83a.7.7,0,0,1-.62-.5.33.33,0,0,1,0-.14c.08-.29.11-.42,1.11-.9a20,20,0,0,1,2.39-1s.23-3,.19-3.65c0-.32-.08-.58-.1-.85s0-.74.37-.77.61.32.69,1.32c0,.28,0,.62,0,1,0,1.14-.12,1.45-.2,2.69a13,13,0,0,1,2.45-.43l.51,0c.4,0,1.08-.08,1.16.44C154.59,36.25,154.38,36.32,154.14,36.34Z'/%3E%3Cpath class='cls-1' d='M174.25,37.47c-.06,1.07-.13,5.41-.25,8.57-.1,2.32-.23,3.54-.2,3.94,0,.07,0,.11,0,.13a1.61,1.61,0,0,1,.32.73c0,.29-.15.53-.65.56s-.77-.24-.79-.54.1-.6.18-.62a45.71,45.71,0,0,0,.29-6.05c.07-2.61.09-4-.06-6.82,0,0-3,4.39-4.1,4.45-.42,0-.59-.45-.64-1.18a35.61,35.61,0,0,1,.19-4.24c0-.46,0-.84.07-1.15a3.86,3.86,0,0,0-.61,0,15.71,15.71,0,0,0-3.11.65,52.26,52.26,0,0,0,0,5.8c0,.32,0,.64.09.93,0,.07.12.33.14.55a.41.41,0,0,1-.42.49h-.08c-.57,0-.71-.69-.74-1a33,33,0,0,1-.08-4c0-1.35.08-1.73.11-2.55a9.29,9.29,0,0,0-1.56.65c-.31.18-.91.81-1.25.83s-.6-.24-.62-.5a.14.14,0,0,1,0-.11c.07-.29.1-.45,1.1-.92a18.55,18.55,0,0,1,2.39-1s.15-1.56.19-3.65v-.11c0-.21-.08-.47-.1-.73s0-.74.38-.77.61.31.69,1.31c0,.28,0,.63,0,1,0,1.14-.12,1.45-.2,2.69a14.16,14.16,0,0,1,2.55-.43c.17,0,.34,0,.51,0,.36,0,1.65,0,1.72.68,0,.46-.49,3.58-.41,4.66,0,.19,0,.32.1.35s0,0,.08,0c.47,0,1.87-2,3.27-3.91.22-.32.25-.91.65-.94a.53.53,0,0,1,.21,0c.31.1.52.84.57,1.55C174.25,37.07,174.25,37.28,174.25,37.47Z'/%3E%3Cpath class='cls-1' d='M177.7,42.26a.76.76,0,0,1-.68-.45,30.43,30.43,0,0,0,0,4.28l.1,1.25a17.58,17.58,0,0,0,.26,2.29.77.77,0,0,1,.12.35.49.49,0,0,1-.41.58.75.75,0,0,1-.72-.74.61.61,0,0,1,.05-.34s0-.08,0-.19c0-.42-.22-1.47-.35-3.18,0-.49-.06-1-.09-1.65a76.44,76.44,0,0,1,.22-8.73s-.48-.1-.51-.53,1-.91,1.27-.93c1.33-.08,4,1,4.15,3.23C181.3,39.16,178.07,42.23,177.7,42.26Zm-.2-7s-.19,1.5-.28,2.6-.19,3.51-.19,3.51,2.81-1.65,3.11-3.74a.73.73,0,0,0,0-.21A3.08,3.08,0,0,0,177.5,35.27Z'/%3E%3Cpath class='cls-1' d='M190.64,38.39c-.39.26-3.22,3.25-5.35,3.41a1.83,1.83,0,0,1-.85-.11,4,4,0,0,1-2.35-3.29,3.1,3.1,0,0,1,0-.68c.33-2.17,2.65-3.8,4.63-3.95a2.85,2.85,0,0,1,1.66.31.14.14,0,0,1,.08.13c0,.47-1.48,1.79-2.5,2.52a6.35,6.35,0,0,1-2.78,1.08,1.89,1.89,0,0,0,0,.55,3,3,0,0,0,.63,1.58,1.67,1.67,0,0,0,1.6.89c1.49-.12,4.23-2.73,4.4-3s.27-.72.59-.74a.62.62,0,0,1,.61.56A.94.94,0,0,1,190.64,38.39Zm-5.61-3a5,5,0,0,0-1.45,1.38,5.36,5.36,0,0,0,2.17-.94,7.15,7.15,0,0,0,1.32-1.12A4.38,4.38,0,0,0,185,35.34Z'/%3E%3Cpath class='cls-1' d='M206.39,39c0,.31.08.57.09.76s0,.44-.47.47-.62-.35-.65-.84,0-1.18-.09-2.2c-.11-1.41-.36-3.06-.8-3.29a.59.59,0,0,0-.31-.06c-1.13.09-3.31,2.56-3.76,3.74a5.55,5.55,0,0,0-.31,2.31c0,.21.06.41.08.64.05.7-.31.93-.65,1a.62.62,0,0,1-.69-.58,1.91,1.91,0,0,1,.19-.8c.17-.45-.22-2.74-.06-7.43.1-3.14-.19-4.75.47-4.8.49,0,.68.2.71.63.05.59-.16,1.59-.18,3.07s-.05,3.15,0,4.87c0,0,2.3-3.51,4.26-3.65a1.46,1.46,0,0,1,.51,0c1.05.29,1.43,2.29,1.57,4.19C206.34,37.63,206.35,38.43,206.39,39Z'/%3E%3Cpath class='cls-1' d='M215.82,36.51c-.4.25-3.23,3.25-5.36,3.41a1.93,1.93,0,0,1-.84-.11,3.93,3.93,0,0,1-2.35-3.29,2.58,2.58,0,0,1,0-.68c.33-2.17,2.66-3.8,4.64-4a2.81,2.81,0,0,1,1.65.31.15.15,0,0,1,.09.13c0,.47-1.48,1.79-2.51,2.52a6.3,6.3,0,0,1-2.78,1.08,2.46,2.46,0,0,0,0,.55,3,3,0,0,0,.64,1.58,1.65,1.65,0,0,0,1.6.88c1.49-.11,4.23-2.72,4.4-3s.27-.72.59-.74a.62.62,0,0,1,.61.56A1,1,0,0,1,215.82,36.51Zm-5.61-3a5,5,0,0,0-1.46,1.38,5.3,5.3,0,0,0,2.17-.94,6.59,6.59,0,0,0,1.32-1.13A4.47,4.47,0,0,0,210.21,33.46Z'/%3E%3Cpath class='cls-1' d='M223.69,31.77c-.24,0-.46-.14-.76-.12a.92.92,0,0,0-.48.19,14.71,14.71,0,0,0-3.66,4.65c-.61,1.11-.26,2.55-.48,2.88a.5.5,0,0,1-.4.24.66.66,0,0,1-.72-.7c0-.57.12-1.55.08-3,0-.5,0-.91-.06-1.29a7.7,7.7,0,0,0-.63-2.95c0-.2.34-.46.53-.47a.63.63,0,0,1,.43.15c.3.25.39.68.51,1.82.07.66.1,1,.19,2.28a26,26,0,0,1,2.3-3A4,4,0,0,1,223,30.7a2.71,2.71,0,0,1,.87.08.59.59,0,0,1,.31.47A.55.55,0,0,1,223.69,31.77Z'/%3E%3Cpath class='cls-1' d='M231.88,35.31c-.39.25-3.22,3.25-5.35,3.41a2,2,0,0,1-.85-.11,4,4,0,0,1-2.35-3.29,3.1,3.1,0,0,1,0-.68c.33-2.17,2.65-3.8,4.63-3.95a2.84,2.84,0,0,1,1.66.31.13.13,0,0,1,.08.13c0,.47-1.47,1.79-2.5,2.52a6.35,6.35,0,0,1-2.78,1.08,2.46,2.46,0,0,0,0,.55,3,3,0,0,0,.63,1.58,1.65,1.65,0,0,0,1.6.88c1.49-.11,4.24-2.72,4.4-3s.27-.72.59-.74a.61.61,0,0,1,.61.56A.94.94,0,0,1,231.88,35.31Zm-5.61-3.05a5,5,0,0,0-1.45,1.38A5.36,5.36,0,0,0,227,32.7a6.88,6.88,0,0,0,1.32-1.13A4.51,4.51,0,0,0,226.27,32.26Z'/%3E%3Cpath d='M45.19,31.37C30.55,32.35,16,34,1.46,36.26a23.3,23.3,0,0,1,2.1-2.88c.35-.47-.39-1-.79-.62A9.15,9.15,0,0,0,0,37.47a.52.52,0,0,0,.25.45,8.63,8.63,0,0,0,2.52.74l3.14.74a.36.36,0,0,0,.2-.69L3.5,37.92c-.56-.18-1.3-.3-1.93-.52a.37.37,0,0,0,.15,0Q23.35,34,45.18,32C45.57,32,45.6,31.34,45.19,31.37ZM1.09,37.22s0-.06,0-.08a.86.86,0,0,0,.13.14Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  position: absolute;
  width: 371px;
  height: 80px;
  right: -363px;
  top: 0px;
  cursor: default;
}
.tzs-cont {
  width: 100%;
}
</style>
